import normalizeWheel from 'normalize-wheel';

const isFirefox =
  typeof navigator !== 'undefined' &&
  navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

const mousewheel = function (element, callback) {
  if (element && element.addEventListener) {
    element.addEventListener(
      isFirefox ? 'DOMMouseScroll' : 'mousewheel',
      function (event) {
        const normalized = normalizeWheel(event);
        callback && callback.apply(this, [event, normalized]);
      }
    );
  }
};

export default {
  bind (el, binding) {
    mousewheel(el, binding.value);
  }
};



// WEBPACK FOOTER //
// ./src/muse-ui/internal/directives/mousewheel.js